<template>
  <div class="marketplace-comments">
    <div class="comments-main-layout">
      <!-- Sol Taraf - Rating Overview -->
      <div class="rating-overview">
        <div class="overall-rating" v-if="analytics">
              <div class="rating-score">
                <div class="big-rating">{{ analytics.overview.averageRatingFormatted }}</div>
                <div class="rating-stars">
                  <img
                      v-for="star in Math.floor(analytics.overview.averageRating)"
                      :key="star"
                      src="@/assets/images/starFill.svg"
                      class="star-icon"
                  />
                </div>
                <div class="rating-label">{{ $t('average') }}</div>
              </div>
            </div>

        <div class="rating-breakdown" v-if="analytics">
              <div
                  v-for="rating in analytics.ratingDistribution.slice().reverse()"
                  :key="rating.rating"
                  class="rating-row"
              >
                <div class="rating-info">
                  <span class="rating-number">{{ rating.rating }}</span>
                  <span class="rating-text">{{$t('and_above')}}</span>
                </div>
                <div class="rating-stars">
                  <img
                      v-for="star in rating.rating"
                      :key="star"
                      src="@/assets/images/starFill.svg"
                      class="star-icon-small"
                  />
                  <img
                      v-for="star in (5 - rating.rating)"
                      :key="'empty-' + star"
                      src="@/assets/images/starOutline.svg"
                      class="star-icon-small"
                  />
                </div>
                <div class="rating-bar">
                  <div
                      class="rating-fill"
                      :style="{ width: rating.percentage + '%' }"
                  ></div>
                </div>
                <div class="rating-percentage">{{ rating.percentage }}%</div>
              </div>
            </div>
      </div>

      <div class="comments-content">
        <div class="comments-list" v-if="!isLoading && commentsData?.data?.length > 0">
          <MarketplaceCommentCard
            v-for="comment in commentsData.data"
            :key="comment.uuid"
            :comment="comment"
              @delete-comment="handleDeleteComment"
          />
        </div>

        <div class="empty-state" v-else-if="!isLoading && (!commentsData?.data || commentsData.data.length === 0)">
          <div class="empty-icon">💬</div>
          <h3>{{$t('no_comments_yet')}}</h3>
          <p>{{$t('inspect_products_to_comment')}}</p>
        </div>

        <LoadingOverlay v-if="isLoading" />

        <Pagination
          v-if="commentsData && commentsData.total > 0"
          :current-page="currentPage"
          :total-items="commentsData.total"
          :per-page="20"
          :on-page-change="handlePageChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import MarketplaceCommentCard from './MarketplaceCommentCard.vue';
import LoadingOverlay from './LoadingOverlay.vue';
import Pagination from './Pagination.vue';

export default {
  name: 'MarketplaceComments',
  components: {
    MarketplaceCommentCard,
    LoadingOverlay,
    Pagination
  },
  props: {
    commentsData: {
      type: Object,
      default: null
    },
    analytics: {
      type: Object,
      default: null
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    currentPage: {
      type: Number,
      default: 1
    }
  },
  methods: {
    handlePageChange(page) {
      this.$emit('page-change', page);
    },
    handleDeleteComment(comment) {
      this.$emit('delete-comment', comment);
    }
  }
}
</script>

<style scoped>
.marketplace-comments {
  width: 100%;
}

/* Ana Layout */
.comments-main-layout {
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100% !important;
}

/* Sol Taraf - Rating Overview */
.rating-overview {
  background: white;
  padding: 24px;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap:24px;

}

.rating-header h2 {
  font-size: 18px;
  font-weight: 600;
  color: #101828;
  margin: 0 0 24px 0;
}

/* Genel Puan */
.overall-rating {
  border-bottom: 1px solid #f3f4f6;
  display: flex;
  align-content: center;
  justify-content: center;
}

.rating-score {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: 100% !important;
}
.flex-row-div{
  display: flex;
  flex-direction: row;
  align-items: start;
  justify-content: start;
}

.big-rating {
  font-size: 56px;
  font-weight: 700;
  color: #101828;
  line-height: 1;
}

.rating-stars {
  display: flex;
  gap: 4px;
  margin-bottom: 8px;
}

.star-icon {
  width: 20px;
  height: 20px;
}

.rating-label {
  font-size: 12px;
  color: #6b7280;
  font-weight: 400;
  margin-top: 4px;
}

/* Puan Dağılımı */
.rating-breakdown {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100% !important;
}

.rating-row {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
}

.rating-info {
  display: flex;
  align-items: center;
  gap: 4px;
  min-width: 70px;
}

.rating-number {
  font-size: 12px;
  color: #374151;
  font-weight: 600;
}

.rating-text {
  font-size: 12px;
  color: #6b7280;
  font-weight: 400;
}

.rating-stars {
  display: flex;
  gap: 2px;
  min-width: 80px;
}

.star-icon-small {
  width: 12px;
  height: 12px;
}

.rating-bar {
  flex: 1;
  height: 6px;
  background: #f3f4f6;
  border-radius: 3px;
  overflow: hidden;
  margin: 0 8px;
}

.rating-fill {
  height: 100%;
  background: #fbbf24;
  transition: width 0.3s ease;
}

.rating-percentage {
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  min-width: 35px;
  text-align: right;
}

/* Sağ Taraf - Yorumlar */
.comments-content {
  flex: 1;
  min-width: 0;
}

.comments-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  margin-bottom: 32px;
}

/* Empty State */
.empty-state {
  text-align: center;
  padding: 48px 24px;
  background: white;
  border: 1px solid #e1e5e9;
  border-radius: 12px;
}

.empty-icon {
  font-size: 64px;
  margin-bottom: 16px;
}

.empty-state h3 {
  font-size: 18px;
  font-weight: 600;
  color: #111827;
  margin: 0 0 8px 0;
}

.empty-state p {
  font-size: 14px;
  color: #6b7280;
  margin: 0;
}

/* Responsive */
@media (max-width: 1024px) {
  .rating-overview {
    flex: 0 0 250px;
  }
}

@media (max-width: 768px) {
  .comments-main-layout {
    flex-direction: column;
    gap: 24px;
  }

  .rating-overview {
    flex: none;
    width: 100%;
  }

  .rating-breakdown {
    gap: 12px;
  }

  .rating-row {
    gap: 6px;
  }

  .rating-info {
    min-width: 60px;
  }

  .rating-number,
  .rating-text {
    font-size: 11px;
  }

  .rating-stars {
    min-width: 70px;
  }

  .big-rating {
    font-size: 48px;
  }

  .comments-list {
    grid-template-columns: 1fr;
  }
}
</style>
